import { render, staticRenderFns } from "./Actors.vue?vue&type=template&id=2ac3abc8&"
import script from "./Actors.vue?vue&type=script&lang=js&"
export * from "./Actors.vue?vue&type=script&lang=js&"
import style0 from "./Actors.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ac3abc8')) {
      api.createRecord('2ac3abc8', component.options)
    } else {
      api.reload('2ac3abc8', component.options)
    }
    module.hot.accept("./Actors.vue?vue&type=template&id=2ac3abc8&", function () {
      api.rerender('2ac3abc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/detail/components/Actors.vue"
export default component.exports